import React, { useState, useEffect } from "react";
import ForwardIcon from "./ForwardIcon";
import { Popover } from "../../actions/Tippy";
import { ReactComponent as GESTOR } from "../../build/images/gestor.svg";

const { connection_platform } = require("../../services/api")
const { forward } = require("../../services/data")

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern
var port = connection_platform.port_backend_intern;

if(gethostname === 'localhost')
  pathname = iplocal;
else
  pathname = gethostname;

var ipcurrent = pathname;

if(pathname !== connection_platform.ip_intern){
    ipcurrent = connection_platform.ip_apache_view_extern;
   // if(parseInt(connection_platform.port_apache_view_extern) !== 80){
       ipcurrent = ipcurrent+':'+connection_platform.port_apache_view_extern;
    //}
}else{
    ipcurrent = connection_platform.ip_apache_view_intern;
   // if(parseInt(connection_platform.port_apache_view_intern) !== 80){
        ipcurrent = ipcurrent+':'+connection_platform.port_apache_view_intern;
    //}
}

const MessageContainerPDF = ({
  positmessage1,
  dia,
  verificarexistencia,
  PDF,
  size,
  IPCurrent,
  url,
  message,
  caption,
  InfoUsers,
  ContactId,
  markstar2,
  handleDirectForward,
  isChecked,
  handleCheck,
  handleReply
}) => {
  const [name, setName] = useState([]);
  const [separador, setSeparador] = useState(url.split("."));

  const author = message.author;
  const typemsg = message.typemsg;
  const infousers = InfoUsers;
  const contactid = ContactId;

  useEffect(() => {
    setName(separador[0].split("/"));
  }, [separador]);

  const handleDropClick = e => {
    e.preventDefault();
    document.getElementById("chat-wrapper").classList.add("active");
    handleCheck(
      isChecked,
      message,
      contactid,
      infousers,
      author,
      typemsg
    )
  };

  const renderPopover = (messageid) => (
    <div className="context-menu drop-forward" id="drop-forward">
      <ul className="context-menu__list">
        {/* <li className="context-menu__item">
          <a href="#" className="context-menu__link" onClick={handleDropClick}>
            Encaminhar
          </a>
        </li> */}
        <li className="context-menu__item"><a className="context-menu__link responder-link" onClick={() => handleReply({messageid})}>Responder</a></li>
      </ul>
    </div>
  );

  // const handleCheck = msg => {
  //   // setChecked(!checked);
  // };

  return (
    <div className={positmessage1}>
      <div className="time">{dia}</div>
      <div className="message__container">
        <div
          className={`checkbox checkbox--checked ${
            positmessage1 !== "message right" ? "checkbox--checked-left" : ""
          }
          ${isChecked ? "active" : ""}
          `}
        >
          <div
            className="checkbox-container"
            onClick={() =>
              handleCheck(
                isChecked,
                message,
                contactid,
                infousers,
                author,
                typemsg
              )
            }
          >
            <div className="checkbox-item">
              <div className="check">
                <i className="material-icons">check</i>
              </div>
            </div>
          </div>
          <div
            className={
              positmessage1 === "message right"
                ? "bubble-container bubble-container--right"
                : "bubble-container bubble-container--left"
            }
          >
            {/* {positmessage1 === "message right" ? (
              (() => {
                if(forward === true){
                  return <ForwardIcon
                            handleDirectForward={() =>
                              handleDirectForward(
                                message,
                                contactid,
                                infousers,
                                author,
                                typemsg
                              )
                            }
                          />
                        }
                      }
                    )()
            ) : (
              ""
            )} */}
            {/* <ForwardIcon handleForwardClick={() => handleForwardClick(message)} /> */}
            <div className="bubble"  id={message.messageid}>

              {positmessage1 === "message right" && message.statusmsg === 'error'? (
                ""
              ) : (
                (() => {
                  if(forward === true){
                    return <Popover
                              trigger="click"
                              interactive={true}
                              content={renderPopover(message.messageid)}
                            >
                              <div className="forward-content">
                                <i
                                  className="material-icons tippy-context-forward tippy-context-menu"
                                  data-tippy-placement="bottom"
                                  data-template="drop-forward"
                                >
                                  keyboard_arrow_down
                                </i>
                              </div>
                            </Popover>
                          }
                        }
                      )()
              )}
               {(() => {
                if (positmessage1 === "message gestor") {
                  return (
                    <>
                      <div className="bubble-user-name">Gestor</div>
                      <div className="icon-gestor">
                        {(() => {
                          if (positmessage1 === "message gestor") {
                            if (message.typemon === "1") {
                              return <GESTOR />;
                            } else if (message.typemon === "2") {
                              return <GESTOR />;
                            } else if (message.typemon === "3") {
                              return <GESTOR />;
                            }
                          }
                        })()}
                        Gestor: {message.username}
                      </div>
                    </>
                  );
                }
              })()}
              <div className="bubble-media">
                {verificarexistencia}
                <div className="bubble-media__mediaInfo">
                  <span className="bubble-media__fileType">
                    <img className="bubble-media__fileIcon" src={PDF} alt="" />
                  </span>
                  <span className="bubble-media__fileName">
                    <p className="bubble-media__text">{name[6]}</p>
                    <br />
                    <div className="fileinfo__bar">
                      <span className="fileinfo__size">{size}</span> •{" "}
                      <span className="fileinfo__type">
                        {separador[1].toUpperCase()}
                      </span>
                    </div>
                  </span>

                  { 
                    (() => { 
                      if(InfoUsers.permdownload === true){
                        return(
                          <div className="bubble-media__download">
                          <a
                            href={connection_platform.type_connect+'://' + ipcurrent + url}
                            target="_blank"
                            download
                            className="bubble-media__btnDownload"
                          >
                            <i className="material-icons">get_app</i>
                          </a>
                        </div>
                        )
                      }
                    })()    
                  }
                  
                </div>
              </div>
              <div className="text">{caption}</div>
              <div className="bubble__info-content">
                <div
                  className={
                    message.favorite === "true"
                      ? "fav fav--inside fav--right active"
                      : "fav fav--inside fav--right"
                  }
                >
                  <i
                    onClick={() =>
                      markstar2(
                        message.messageid,
                        InfoUsers.id,
                        message.favorite,
                        ContactId.idatendimento
                      )
                    }
                    className="material-icons fav-icon"
                  >
                    {message.favorite === "true" ? "star" : "star_border"}
                  </i>
                </div>
                <div className="bubble__info-content__time">
                  {message.datatime}
                </div>
                  {(() => {
                    if (positmessage1 !== "message left") {
                      if(message.statusmsg === 'error')
                            return (
                              <div
                                className={
                                  "message-info message-info--" + message.statusmsg
                                }
                              >
                                <i className="material-icons">error</i>
                              </div>
                            );
                      else  if(message.statusmsg === 'entregue')
                            return (
                              <div
                                className={
                                  "message-info"
                                }
                              >
                                <i className="material-icons">done_all</i>
                              </div>
                            ); 
                      else  if(message.statusmsg === 'visto')
                            return (
                              <div
                                className={
                                  "message-info message-info--visto"
                                }
                              >
                                <i className="material-icons">done_all</i>
                              </div>
                            ); 
                      else  
                        return (
                          <div
                            className={
                              "message-info"
                            }
                          >
                            <i className="material-icons">done</i>
                          </div>
                        );                     }
                  })()}
              </div>
              {positmessage1 === "message right" && message.statusmsg !== 'error'? (
                (() => {
                  if(forward === true){
                    return <Popover
                              trigger="click"
                              interactive={true}
                              content={renderPopover(message.messageid)}
                            >
                              <div className="forward-content">
                                <i
                                  className="material-icons tippy-context-forward tippy-context-menu"
                                  data-tippy-placement="bottom"
                                  data-template="drop-forward"
                                >
                                  keyboard_arrow_down
                                </i>
                              </div>
                            </Popover>
                     }
                    }
                  )()
              ) : (
                ""
              )}
            </div>
            {/* {positmessage1 === "message right" ? (
              ""
            ) : (
              (() => {
                if(forward === true){
                  return <ForwardIcon
                    handleDirectForward={() =>
                      handleDirectForward(
                        message,
                        contactid,
                        infousers,
                        author,
                        typemsg
                      )
                    }
                  />
                  }
                }
              )()
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageContainerPDF;
